import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  styled,
  type SelectProps,
  type FormControlProps,
} from '@mui/material';
import { FocusEvent, ReactNode, useState } from 'react';

type DropdownSelectProps<T> = SelectProps<T[]> & {
  label: ReactNode;
  formControlProps?: FormControlProps;
};

const StyledLabel = styled(InputLabel)`
  transition-delay: 0ms;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-property: color, transform, max-width, top;
  top: 50%;
  left: 0;
  transform: translate(14px, -50%) scale(1);
  &.open {
    top: 0;
    transform: translate(14px, -9px) scale(0.75);
  }
`;

export function MHMDropdownSelect<T>(props: DropdownSelectProps<T>) {
  const {
    label,
    labelId,
    children,
    value,
    onFocus,
    onBlur,
    formControlProps,
    ...rest
  } = props;
  const [isOpen, setIsOpen] = useState(false);

  const labelClass = isOpen || value?.length ? 'open' : '';

  function handleFocus(
    e: FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
  ) {
    setIsOpen(true);
    onFocus?.(e);
  }

  function handleBlur(
    e: FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
  ) {
    setIsOpen(false);
    onBlur?.(e);
  }

  return (
    <FormControl
      sx={{ my: 1, width: '100%', ...formControlProps?.sx }}
      {...formControlProps}
    >
      <StyledLabel id={labelId} className={labelClass}>
        {label}
      </StyledLabel>
      <Select
        labelId={labelId}
        multiple
        input={<OutlinedInput label={label} size="small" />}
        value={value}
        fullWidth
        onFocus={handleFocus}
        onBlur={handleBlur}
        {...rest}
      >
        {children}
      </Select>
    </FormControl>
  );
}
